// @flow

export type AbsenceReviewSchemaArgs = $Exact<{
  task: Object,
  readonly: boolean,
  reviewPeriodLength: number,
  t: (id: string, obj?: Object) => string,
}>;

export function schemaFnc({ task, readonly, reviewPeriodLength, t }: AbsenceReviewSchemaArgs) {
  const actionEnum = ["LOG_ACTION", "NO_ACTION"];
  const actionEnumNames = [t("ASSIGN_NEW_LEVEL"), t("MAINTAIN_CURRENT_STATUS")];

  if (readonly === true) {
    actionEnum.push("DEFER");
    actionEnumNames.push(t("TEMPRORARILY_DEFER"));
  }

  return {
    type: "object",
    required: ["action", "notes"],
    dependencies: {
      action: {
        oneOf: [
          {
            properties: {
              action: { const: "NO_ACTION" },
              noActionReason: {
                type: "object",
                title: t("PLEASE_SELECT_A_REASON"),
                required: ["id"],
                properties: {
                  id: {
                    type: "integer",
                    title: t("PLEASE_SELECT_A_REASON"),
                    oneOf: task.noActionReasons
                      ? task.noActionReasons.map(a => ({
                          const: a.id,
                          title: a.reason,
                        }))
                      : [],
                  },
                },
              },
            },
            required: ["noActionReason"],
          },
          {
            properties: {
              action: { const: "LOG_ACTION" },
              ...(!readonly
                ? {
                    newLevel: {
                      type: "object",
                      title: "New Level",
                      required: ["id"],
                      properties: {
                        id: {
                          type: "integer",
                          title: t("NEW_ABSENCE_MONITORING_LEVEL"),
                          oneOf: (() => {
                            const { levels, currentLevel } = task;
                            let lev = [{ id: -1, name: "-" }];
                            if (currentLevel) lev = [currentLevel];
                            if (levels.length) lev = levels;
                            //$FlowIgnore
                            return lev.map((a: { id: number, name: string }) => ({
                              const: a.id,
                              title: a.name,
                            }));
                          })(),
                        },
                      },
                    },
                  }
                : {}),
              ...(readonly && task.newLevel
                ? {
                    newLevel: {
                      type: "object",
                      title: "New Level",
                      required: ["id"],
                      properties: {
                        id: {
                          type: "integer",
                          title: t("NEW_ABSENCE_MONITORING_LEVEL"),
                          oneOf: (() => {
                            if (readonly && task.newLevel) {
                              return [
                                {
                                  const: task.newLevel.id,
                                  title: task.newLevel.name,
                                },
                              ];
                            }

                            return [{ const: -1, title: "-" }];
                          })(),
                        },
                      },
                    },
                  }
                : {}),
              ...(readonly && !task.newLevel && task.currentLevel
                ? {
                    currentLevel: {
                      type: "object",
                      title: "New Level",
                      required: ["id"],
                      properties: {
                        id: {
                          type: "integer",
                          title: t("NEW_ABSENCE_MONITORING_LEVEL"),
                          oneOf: (() => {
                            if (readonly && task.currentLevel) {
                              return [
                                {
                                  const: task.currentLevel.id,
                                  title: task.currentLevel.name,
                                },
                              ];
                            }

                            return [{ const: -1, title: "" }];
                          })(),
                        },
                      },
                    },
                  }
                : {}),
              meetingDate: {
                type: "string",
                title: t("EFFECTIVE_FROM_DATE"),
                format: "date",
              },
              additionalSupportActionsTaken: {
                type: "array",
                title: t("STEP_ADDITIONAL_SUPPORT_ACTIONS"),
                items: {
                  type: "object",
                  required: ["id"],
                  properties: {
                    id: {
                      type: "integer",
                      title: "Absence Monitoring Additional Support Action",
                      oneOf: task.additionalSupportActions
                        ? task.additionalSupportActions.map(a => ({
                            const: a.id,
                            title: a.action,
                          }))
                        : [{ const: -1, title: "" }],
                    },
                  },
                },
              },
              nextReviewDate: {
                type: "string",
                title: t("SET_REVIEW_DATE"),
                format: "date",
              },
            },
            required: ["newLevel", "meetingDate"],
          },
        ],
      },
    },
    properties: {
      // required oneOf field with dependencies does not allow to select empty strings/nulls/-1 (very convenient, yes)
      // as an alternative we can use enums properties with min lengths field
      action: {
        type: "string",
        title: t("DECISION_MADE"),
        enum: actionEnum,
        enumNames: actionEnumNames,
        default: "",
        minLength: 1,
      },
      notes: {
        type: "string",
        title: t("ADDITIONAL_NOTES"),
      },
    },
    urn: "urn:jsonschema:eu:firstcare:api:v1:dto:tools:tasks:AbsenceMonitoringReviewTaskDTO",
  };
}
